<template>
  <div>
    <div>{{ label }}</div>
    <b-form-input :id="`${label}-input`" type="date" :value="value" @input="onInput" />
  </div>
</template>

<script>
export default {
  name: "DataEnabledNumberInput",

  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },

  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>
